import { render } from "./LabeledCheckbox.vue?vue&type=template&id=44722182&scoped=true"
import script from "./LabeledCheckbox.vue?vue&type=script&lang=js"
export * from "./LabeledCheckbox.vue?vue&type=script&lang=js"

import "./LabeledCheckbox.vue?vue&type=style&index=0&id=44722182&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44722182"]])

export default __exports__